const DASHBOARD_HOST_SUFFIX = ".dashboard.playbrain.com"

const DASHBOARD_APP_PREFIXES = ["/dashboard", "/login", "/auth", "/api"]

export function isDashboardHostname(hostname: string) {
  const normalizedHostname = hostname.split(":")[0]?.toLowerCase() ?? ""
  return (
    normalizedHostname === "dashboard.playbrain.com" || normalizedHostname.endsWith(DASHBOARD_HOST_SUFFIX)
  )
}

export function shouldRouteDashboardHostToCms(hostname: string, pathname: string) {
  if (!isDashboardHostname(hostname)) return false
  const normalizedPathname = pathname.split(/[?#]/)[0] || "/"
  return !DASHBOARD_APP_PREFIXES.some(
    (prefix) => normalizedPathname === prefix || normalizedPathname.startsWith(`${prefix}/`)
  )
}
